import styled from "styled-components";
import { Z_INDEX } from "../constants/zIndex";
import { handleLink } from "../utils/handleLink";

const Footer = () => {
  return (
    <Wrapper>
      <SNSWrapper>
        <div
          onClick={() =>
            handleLink("https://www.instagram.com/catch_teenieping_official/")
          }
        >
          <img src="/assets/icon_insta.png" alt="goto insta" />
        </div>
        <div
          onClick={() =>
            handleLink(
              "https://www.youtube.com/channel/UCtm_ppWxsfRzxaYXMA2bqMw"
            )
          }
        >
          <img src="/assets/icon_youtube.png" alt="goto youtube" />
        </div>
        <div
          onClick={() =>
            handleLink(
              "https://www.tiktok.com/@catchteenieping_official?lang=ko-KR"
            )
          }
        >
          <img src="/assets/icon_tiktok.png" alt="goto tiktok" />
        </div>
      </SNSWrapper>
      <p>ⓒ 2024. SAMG. All rights reserved.</p>
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 26px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--primary);
  color: var(--white);
  z-index: ${Z_INDEX.CONTENT};
  font-size: 1.4rem;
`;

const SNSWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 36px;
  margin-bottom: 20px;

  > div {
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
`;
